module.exports = __webpack_public_path__ + "img/cast.9302719f.png";